/* Importando a biblioteca axios. */
import axios from 'axios';



/* Criando uma nova instância de axios com um baseURL. */
export const api = axios.create({
    baseURL: 'https://elasgen.herokuapp.com/'
})


/* Uma função que está sendo exportada. */
export const cadastroUsuario = async (url: any, dados: any, setDado: any) => {
/* Enviando uma requisição para o servidor. */
    const resposta = await api.post(url, dados)
/* Configurando o estado do componente. */
    setDado(resposta.data)
}

/* Uma função que está sendo exportada. */
export const login = async (url: any, dados: any, setDado: any) => {
/* Enviando uma requisição para o servidor. */
    const resposta = await api.post(url, dados)
/* Configurando o estado do componente. */
setDado(resposta.data.token)
}

export const busca = async (url: any, setDado: any, header: any) => {
    const resposta = await api.get(url, header)
    setDado(resposta.data)
}

export const buscaId = async (url: any, setDado: any, header: any) => {
    const resposta = await api.get(url, header)
    setDado(resposta.data)
}

export const post = async(url: any, dados: any, setDado: any, header: any) => {
    const resposta = await api.post(url, dados, header)
    setDado(resposta.data)
}

export const put = async (url: any, dados: any, setDado: any, header: any) => {
    const resposta = await api.put(url, dados, header)
    setDado(resposta.data)
}

export const deleteId = async (url: any, header: any) => {
    await api.delete(url, header)
    
}